import { configureStore } from '@reduxjs/toolkit';

import authReducer from "./slices/Auth";
import messageReducer from "./slices/Message";
import profileReducer from './slices/Profile'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        message: messageReducer,
        profile: profileReducer
    },
});

export const profileStore = configureStore({
    reducer: {},
});

export default store;